/**
 * Firewall Finder â€” Interactive wizard for firewall recommendations
 * Embedded in the homepage hero section. 3 questions â†’ 3 SonicWall recommendations.
 */
(function() {
  'use strict';

  /* ============================================================
     FIREWALL SPEC DATA (from collection-template.liquid)
     ============================================================ */
  var FIREWALLS = [
    { id: 'tz80',    name: 'TZ80',     series: 'TZ Series',  users: '1-10',    fw: '750 Mbps',   vpn: '750 Mbps',  ips: '750 Mbps',  conn: '300K',     collection: 'sonicwall-tz80-firewall-series',       bullets: ['0.9 Gbps firewall throughput', '4\u00d7 1GbE + 1x SFP ports', 'Ideal for home office & SOHO'] },
    { id: 'tz280',   name: 'TZ280',    series: 'TZ Series',  users: '10-25',   fw: '2.5 Gbps',   vpn: '1.2 Gbps',  ips: '1.5 Gbps',  conn: '1M',       collection: 'sonicwall-tz280-firewall-series',      bullets: ['2.5 Gbps firewall throughput', '8\u00d7 1GbE + 2x SFP ports', 'Small office, up to 25 users'] },
    { id: 'tz380',   name: 'TZ380',    series: 'TZ Series',  users: '25-50',   fw: '3.5 Gbps',   vpn: '1.6 Gbps',  ips: '2.0 Gbps',  conn: '1.1M',     collection: 'sonicwall-tz380-firewall-series',      bullets: ['3.5 Gbps firewall throughput', '8\u00d7 1GbE + 2\u00d7 5G SFP+ ports', 'Growing business, up to 50 users'] },
    { id: 'tz480',   name: 'TZ480',    series: 'TZ Series',  users: '50-75',   fw: '4.0 Gbps',   vpn: '2.0 Gbps',  ips: '2.2 Gbps',  conn: '1.2M',     collection: 'sonicwall-tz480-firewall-series',      bullets: ['4.0 Gbps firewall throughput', '8\u00d7 1GbE + 2\u00d7 5G SFP+ ports', 'Mid-size office, up to 100 users'] },
    { id: 'tz580',   name: 'TZ580',    series: 'TZ Series',  users: '75-150',  fw: '4.5 Gbps',   vpn: '2.2 Gbps',  ips: '2.5 Gbps',  conn: '1.4M',     collection: 'sonicwall-tz580-firewall-series',      bullets: ['4.5 Gbps firewall throughput', '8\u00d7 1GbE + 2\u00d7 5G SFP+ ports', 'SD-Branch ready, up to 120 users'] },
    { id: 'tz680',   name: 'TZ680',    series: 'TZ Series',  users: '150-250', fw: '5.0 Gbps',   vpn: '2.5 Gbps',  ips: '3.0 Gbps',  conn: '1.6M',     collection: 'sonicwall-tz680-firewall-series',      bullets: ['5.0 Gbps firewall throughput', '8\u00d7 1GbE + 2\u00d7 10G SFP+ ports', 'Highest TZ performance, up to 150 users'] },
    { id: 'nsa2800', name: 'NSa 2800', series: 'NSa Series', users: '250-500', fw: '8.0 Gbps',   vpn: '5.5 Gbps',  ips: '7.0 Gbps',  conn: '2M',       collection: 'sonicwall-nsa-2800-firewall-series',   bullets: ['8 Gbps firewall throughput', '16\u00d7 1GbE + 3\u00d7 10G SFP+', '1U rack-mount, redundant PSU'] },
    { id: 'nsa3800', name: 'NSa 3800', series: 'NSa Series', users: '500-1K',  fw: '12.0 Gbps',  vpn: '8.0 Gbps',  ips: '8.0 Gbps',  conn: '3M',       collection: 'sonicwall-nsa-3800-firewall-series',   bullets: ['12 Gbps firewall throughput', '24\u00d7 1GbE + 10\u00d7 10G SFP+', '256 GB storage, redundant fans'] },
    { id: 'nsa4800', name: 'NSa 4800', series: 'NSa Series', users: '1K-2.5K', fw: '20.0 Gbps',  vpn: '10.0 Gbps', ips: '13.0 Gbps', conn: '6M',       collection: 'sonicwall-nsa-4800-firewall-series',   bullets: ['20 Gbps firewall throughput', '24\u00d7 1GbE + 8\u00d7 10G SFP+', 'Up to 10M DPI connections'] },
    { id: 'nsa5800', name: 'NSa 5800', series: 'NSa Series', users: '2.5K-5K', fw: '30.0 Gbps',  vpn: '21.0 Gbps', ips: '24.0 Gbps', conn: '8M',       collection: 'sonicwall-nsa-5800-firewall-series',   bullets: ['30 Gbps firewall throughput', '24\u00d7 1GbE + 8\u00d7 10G SFP+', 'Up to 12M DPI connections'] },
    { id: 'nsa6800', name: 'NSa 6800', series: 'NSa Series', users: '5K+',     fw: '55.0 Gbps',  vpn: '30.0 Gbps', ips: '40.0 Gbps', conn: '20M',      collection: 'sonicwall-nsa-6800-firewall-series',   bullets: ['55 Gbps firewall throughput', '1GbE, 10G SFP+ & 4\u00d7 40G QSFP', 'Flagship NSa, 15M DPI connections'] }
  ];

  /* Map from size â†’ candidate pool indices */
  var SIZE_POOLS = {
    home:       [0, 1, 2],           // TZ80, TZ280, TZ380
    smb:        [1, 2, 3, 4],        // TZ280, TZ380, TZ480, TZ580
    mid:        [3, 4, 5, 6],        // TZ480, TZ580, TZ680, NSa 2800
    enterprise: [6, 7, 8, 9, 10]     // NSa 2800 .. NSa 6800
  };

  /* Priority determines which 3 to pick from pool */
  var PRIORITY_PICK = {
    value:       function(pool) { return pool.slice(0, 3); },
    security:    function(pool) { return pool.length <= 3 ? pool : pool.slice(Math.floor((pool.length - 3) / 2), Math.floor((pool.length - 3) / 2) + 3); },
    performance: function(pool) { return pool.slice(-3); }
  };

  /* Deployment â†’ search variant keyword (NEVER Appliance Only) */
  var DEPLOY_VARIANT = {
    new_setup:  'TotalSecure Advanced Edition 1YR',
    replacing:  'Secure Upgrade Plus',
    expanding:  'TotalSecure Advanced Edition 1YR'
  };

  var DEPLOY_FALLBACK = 'TotalSecure Advanced Edition';


  /* ============================================================
     STATE
     ============================================================ */
  var state = { step: 'size', size: null, deploy: null, priority: null };
  var root = document.getElementById('firewall-finder');
  if (!root) return;

  /* Results render in a separate container below the hero (if available) */
  var resultsContainer = document.getElementById('firewall-finder-results') || root;

  /* ============================================================
     CHECK FOR SAVED RESULTS ON LOAD
     ============================================================ */
  var restoredFromSave = false;
  var params = new URLSearchParams(window.location.search);
  if (params.get('ff') === '1' && params.get('size') && params.get('deploy') && params.get('priority')) {
    /* Auto-load from URL params (shared/bookmarked link) */
    state.size = params.get('size');
    state.deploy = params.get('deploy');
    state.priority = params.get('priority');
    state.step = 'results';
    restoredFromSave = true;
  } else {
    /* Auto-load from localStorage on return visits */
    try {
      var saved = JSON.parse(localStorage.getItem('ntsecurity_firewall_finder'));
      if (saved && saved.size && saved.deploy && saved.priority) {
        state.size = saved.size;
        state.deploy = saved.deploy;
        state.priority = saved.priority;
        state.step = 'results';
        restoredFromSave = true;
      }
    } catch (e) {}
  }

  render();

  /* ============================================================
     RECOMMENDATION ENGINE
     ============================================================ */
  function getRecommendations(size, priority) {
    var poolIndices = SIZE_POOLS[size] || SIZE_POOLS.smb;
    var picked = PRIORITY_PICK[priority] ? PRIORITY_PICK[priority](poolIndices) : poolIndices.slice(0, 3);
    return picked.map(function(i) { return FIREWALLS[i]; });
  }

  /* ============================================================
     PRODUCT FETCHING â€” Shopify Search API
     ============================================================ */
  function fetchProducts(models, deploy, callback) {
    var variantKeyword = DEPLOY_VARIANT[deploy] || DEPLOY_VARIANT.new_setup;
    var results = [];
    var pending = models.length;

    models.forEach(function(model, idx) {
      var query = 'SonicWall ' + model.name + ' ' + variantKeyword;
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          var match = findBestMatch(products, model.name, variantKeyword);
          if (!match) {
            /* Fallback: try generic TotalSecure search */
            return fetch('/search/suggest.json?q=' + encodeURIComponent('SonicWall ' + model.name + ' ' + DEPLOY_FALLBACK) + '&resources[type]=product&resources[limit]=10')
              .then(function(r2) { return r2.json(); })
              .then(function(data2) {
                var prods2 = (data2.resources && data2.resources.results && data2.resources.results.products) || [];
                match = findBestMatch(prods2, model.name, DEPLOY_FALLBACK);
                results[idx] = { model: model, product: match };
              });
          }
          results[idx] = { model: model, product: match };
        })
        .catch(function() {
          results[idx] = { model: model, product: null };
        })
        .finally(function() {
          pending--;
          if (pending === 0) callback(results);
        });
    });
  }

  function findBestMatch(products, modelName, variantKeyword) {
    if (!products || products.length === 0) return null;
    /* Prefer exact model name + variant keyword match */
    var modelLower = modelName.toLowerCase();
    var kwLower = variantKeyword.toLowerCase();
    for (var i = 0; i < products.length; i++) {
      var title = products[i].title.toLowerCase();
      if (title.indexOf(modelLower) !== -1 && title.indexOf(kwLower) !== -1 && title.indexOf('appliance only') === -1 && title.indexOf('secure connect') === -1) {
        return products[i];
      }
    }
    /* Partial match â€” model name + NOT appliance only or Secure Connect */
    for (var j = 0; j < products.length; j++) {
      var t = products[j].title.toLowerCase();
      if (t.indexOf(modelLower) !== -1 && t.indexOf('appliance only') === -1 && t.indexOf('rack mount') === -1 && t.indexOf('secure connect') === -1) {
        return products[j];
      }
    }
    return null;
  }


  /* ============================================================
     RENDER ENGINE
     ============================================================ */
  function render() {
    switch (state.step) {
      case 'size':     renderSize(); break;
      case 'deploy':   renderDeploy(); break;
      case 'priority': renderPriority(); break;
      case 'results':  renderResults(); break;
    }
  }

  function renderStepHeader(stepNum, total, title) {
    return '<div class="ff-step-header">' +
      '<div class="ff-step-indicator">' +
        '<span class="ff-step-num">Step ' + stepNum + ' of ' + total + '</span>' +
        '<div class="ff-step-bar"><div class="ff-step-bar-fill" style="width:' + Math.round(stepNum / total * 100) + '%"></div></div>' +
      '</div>' +
      '<h3 class="ff-step-title">' + title + '</h3>' +
    '</div>';
  }

  /* ---- Step 1: Business Size ---- */
  function renderSize() {
    root.innerHTML =
      '<div class="ff-panel ff-slide-in">' +
        '<div class="ff-panel-top">' +
          '<h2 class="ff-widget-heading">&#x1f50d; Find Your Perfect Firewall</h2>' +
          '<p class="ff-widget-sub">Answer 3 quick questions &mdash; get a personalized recommendation.</p>' +
        '</div>' +
        renderStepHeader(1, 3, 'What best describes your environment?') +
        '<div class="ff-options">' +
          '<button class="ff-option" data-value="home">' +
            '<span class="ff-option-icon">&#x1f3e0;</span>' +
            '<div class="ff-option-text"><span class="ff-option-label">Home Office</span><span class="ff-option-desc">1 &ndash; 10 users</span></div>' +
          '</button>' +
          '<button class="ff-option" data-value="smb">' +
            '<span class="ff-option-icon">&#x1f3e2;</span>' +
            '<div class="ff-option-text"><span class="ff-option-label">Small Business</span><span class="ff-option-desc">10 &ndash; 50 users</span></div>' +
          '</button>' +
          '<button class="ff-option" data-value="mid">' +
            '<span class="ff-option-icon">&#x1f3ed;</span>' +
            '<div class="ff-option-text"><span class="ff-option-label">Mid-size Business</span><span class="ff-option-desc">50 &ndash; 250 users</span></div>' +
          '</button>' +
          '<button class="ff-option" data-value="enterprise">' +
            '<span class="ff-option-icon">&#x1f310;</span>' +
            '<div class="ff-option-text"><span class="ff-option-label">Enterprise</span><span class="ff-option-desc">250+ users</span></div>' +
          '</button>' +
        '</div>' +
      '</div>';
    bindOptions('size', 'deploy');
  }

  /* ---- Step 2: Deployment ---- */
  function renderDeploy() {
    root.innerHTML =
      '<div class="ff-panel ff-slide-in">' +
        '<div class="ff-panel-top">' +
          '<h2 class="ff-widget-heading">&#x1f50d; Find Your Perfect Firewall</h2>' +
          '<p class="ff-widget-sub">Answer 3 quick questions &mdash; get a personalized recommendation.</p>' +
        '</div>' +
        renderStepHeader(2, 3, 'What type of deployment is this?') +
        '<div class="ff-options ff-options-3">' +
          '<button class="ff-option" data-value="new_setup">' +
            '<span class="ff-option-icon">&#x2728;</span>' +
            '<div class="ff-option-text"><span class="ff-option-label">New Network</span><span class="ff-option-desc">Setting up from scratch</span></div>' +
          '</button>' +
          '<button class="ff-option" data-value="replacing">' +
            '<span class="ff-option-icon">&#x1f504;</span>' +
            '<div class="ff-option-text"><span class="ff-option-label">Replacing / Upgrading</span><span class="ff-option-desc">Swapping an older firewall</span></div>' +
          '</button>' +
          '<button class="ff-option" data-value="expanding">' +
            '<span class="ff-option-icon">&#x1f4c8;</span>' +
            '<div class="ff-option-text"><span class="ff-option-label">Expanding Network</span><span class="ff-option-desc">Adding capacity or HA</span></div>' +
          '</button>' +
        '</div>' +
        '<button class="ff-back" onclick="window._ffBack(\'size\')">&larr; Back</button>' +
      '</div>';
    bindOptions('deploy', 'priority');
  }

  /* ---- Step 3: Priority ---- */
  function renderPriority() {
    root.innerHTML =
      '<div class="ff-panel ff-slide-in">' +
        '<div class="ff-panel-top">' +
          '<h2 class="ff-widget-heading">&#x1f50d; Find Your Perfect Firewall</h2>' +
          '<p class="ff-widget-sub">Answer 3 quick questions &mdash; get a personalized recommendation.</p>' +
        '</div>' +
        renderStepHeader(3, 3, 'What\'s your top priority?') +
        '<div class="ff-options ff-options-3">' +
          '<button class="ff-option" data-value="value">' +
            '<span class="ff-option-icon">&#x1f4b0;</span>' +
            '<div class="ff-option-text"><span class="ff-option-label">Best Value</span><span class="ff-option-desc">Most bang for your buck</span></div>' +
          '</button>' +
          '<button class="ff-option" data-value="security">' +
            '<span class="ff-option-icon">&#x1f6e1;&#xfe0f;</span>' +
            '<div class="ff-option-text"><span class="ff-option-label">Maximum Security</span><span class="ff-option-desc">Strongest threat protection</span></div>' +
          '</button>' +
          '<button class="ff-option" data-value="performance">' +
            '<span class="ff-option-icon">&#x26a1;</span>' +
            '<div class="ff-option-text"><span class="ff-option-label">Top Performance</span><span class="ff-option-desc">Highest throughput &amp; speed</span></div>' +
          '</button>' +
        '</div>' +
        '<button class="ff-back" onclick="window._ffBack(\'deploy\')">&larr; Back</button>' +
      '</div>';
    bindOptions('priority', 'results');
  }

  /* ---- Bind option clicks ---- */
  function bindOptions(field, nextStep) {
    var buttons = root.querySelectorAll('.ff-option');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function() {
        state[field] = this.getAttribute('data-value');
        state.step = nextStep;
        render();
      });
    }
  }

  /* ---- Back button ---- */
  window._ffBack = function(toStep) {
    state.step = toStep;
    render();
  };

  /* ---- Helper: clear saved state ---- */
  function clearState() {
    state = { step: 'size', size: null, deploy: null, priority: null };
    resultsContainer.innerHTML = '';
    try { localStorage.removeItem('ntsecurity_firewall_finder'); } catch (e) {}
    if (window.history.replaceState) {
      var url = new URL(window.location);
      url.searchParams.delete('ff');
      url.searchParams.delete('size');
      url.searchParams.delete('deploy');
      url.searchParams.delete('priority');
      window.history.replaceState({}, '', url);
    }
  }

  /* ---- Step 4: Results ---- */
  function renderResults() {
    var models = getRecommendations(state.size, state.priority);

    /* Auto-save to localStorage whenever results are shown */
    try {
      localStorage.setItem('ntsecurity_firewall_finder', JSON.stringify({
        size: state.size, deploy: state.deploy, priority: state.priority, saved: Date.now()
      }));
    } catch (e) {}

    /* Show compact summary in hero panel if results go below */
    if (resultsContainer !== root) {
      root.innerHTML =
        '<div class="ff-panel ff-panel-done ff-slide-in">' +
          '<div class="ff-done-header">' +
            '<span class="ff-done-check">&#x2714;</span>' +
            '<span class="ff-done-badge">Firewall Finder</span>' +
          '</div>' +
          '<h3 class="ff-step-title">Your recommendations are ready!</h3>' +
          '<a href="#firewall-finder-results" class="ff-done-desc ff-done-link">Scroll down to see your SonicWall firewall recommendations &darr;</a>' +
          '<button class="ff-restart-btn-hero" id="ff-hero-restart">&#x21bb; Start Over with New Answers</button>' +
        '</div>';
      var heroRestart = document.getElementById('ff-hero-restart');
      if (heroRestart) {
        heroRestart.addEventListener('click', function() {
          clearState();
          render();
        });
      }
    } else {
      root.innerHTML = '';
    }
    var useWrapper = (resultsContainer !== root);
    resultsContainer.innerHTML =
      (useWrapper ? '<div class="container">' : '') +
      '<div class="ff-results ff-slide-in">' +
        '<div class="ff-results-header">' +
          '<h2 class="ff-results-title">Unique Firewall Solutions for You</h2>' +
          '<p class="ff-results-subtitle">Based on your selections, we recommend these firewalls.</p>' +
        '</div>' +
        '<div class="ff-results-grid" id="ff-results-grid">' +
          '<div class="ff-loading"><div class="ff-spinner"></div><span>Finding the best products for you...</span></div>' +
        '</div>' +
        '<div class="ff-results-actions">' +
          '<button class="ff-save-btn" id="ff-save-btn">Save Results for Later</button>' +
          '<button class="ff-restart-btn" id="ff-restart-btn">Start Over</button>' +
        '</div>' +
      '</div>' +
      (useWrapper ? '</div>' : '');

    /* Scroll to results â€” but not on page load when restoring saved state */
    if (!restoredFromSave && resultsContainer) {
      var titleEl = resultsContainer.querySelector('.ff-results-title');
      var target = titleEl || resultsContainer;
      var headerHeight = document.querySelector('.site-header') ? document.querySelector('.site-header').offsetHeight : 0;
      var y = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 24;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    restoredFromSave = false;

    document.getElementById('ff-restart-btn').addEventListener('click', function() {
      clearState();
      render();
    });

    document.getElementById('ff-save-btn').addEventListener('click', function() {
      saveResults();
      this.textContent = 'Saved!';
      this.classList.add('ff-saved');
      setTimeout(function() {
        var btn = document.getElementById('ff-save-btn');
        if (btn) { btn.textContent = 'Save Results for Later'; btn.classList.remove('ff-saved'); }
      }, 3000);
    });

    /* Fetch real product data — SonicWall only */
    fetchProducts(models, state.deploy, function(results) {
      var grid = document.getElementById('ff-results-grid');
      if (!grid) return;

      var html = '';
      var labels = ['Best Match', 'Great Alternative', 'Also Consider'];
      for (var i = 0; i < results.length; i++) {
        html += renderProductCard(results[i], labels[i], i === 0);
      }
      grid.innerHTML = html;

      var cartBtns = grid.querySelectorAll('.ff-atc-btn');
      for (var j = 0; j < cartBtns.length; j++) {
        cartBtns[j].addEventListener('click', addToCart);
      }
    });
  }

  function renderProductCard(result, label, isBest) {
    var model = result.model;
    var product = result.product;

    /* Use full product title from Shopify, fall back to model name */
    var displayName = (product && product.title) ? product.title : 'SonicWall ' + model.name;

    var priceHTML = '';
    var actionHTML = '';
    if (product) {
      var rawPrice = String(product.price_min || product.price || '0').replace(/[^0-9.]/g, '');
      var price = parseFloat(rawPrice);
      var priceFormatted = price.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

      priceHTML = '<div class="ff-price-block">' +
        '<span class="ff-price">' + priceFormatted + '</span>' +
      '</div>';

      actionHTML = '<div class="ff-card-actions">' +
        '<a href="' + product.url + '" class="ff-atc-btn ff-atc-link">Learn More &rarr;</a>' +
      '</div>';
    } else {
      priceHTML = '<div class="ff-price-block"><span class="ff-price">Contact for pricing</span></div>';
      actionHTML = '<div class="ff-card-actions">' +
        '<a href="/collections/' + model.collection + '" class="ff-atc-btn ff-atc-link">Learn More &rarr;</a>' +
      '</div>';
    }

    var imageHTML = '';
    var imageLink = product ? product.url : '/collections/' + model.collection;
    if (product && product.image) {
      imageHTML = '<a href="' + imageLink + '"><img src="' + product.image + '" alt="' + displayName + '" loading="lazy"></a>';
    } else {
      imageHTML = '<a href="' + imageLink + '"><div class="ff-placeholder-img"><span>SonicWall</span></div></a>';
    }

    return '<div class="ff-card' + (isBest ? ' ff-card-featured' : '') + '">' +
      '<div class="ff-card-badge">' + label + '</div>' +
      '<div class="ff-card-image">' + imageHTML + '</div>' +
      '<div class="ff-card-body">' +
        '<div class="ff-card-series">' + model.series + '</div>' +
        '<h3 class="ff-card-name">' + displayName + '</h3>' +
        '<ul class="ff-card-bullets">' +
          '<li>' + model.bullets[0] + '</li>' +
          '<li>' + model.bullets[1] + '</li>' +
          '<li>' + model.bullets[2] + '</li>' +
        '</ul>' +
        '<div class="ff-card-specs">' +
          '<div class="ff-spec"><span class="ff-spec-val">' + model.fw + '</span><span class="ff-spec-label">Firewall</span></div>' +
          '<div class="ff-spec"><span class="ff-spec-val">' + model.vpn + '</span><span class="ff-spec-label">VPN</span></div>' +
          '<div class="ff-spec"><span class="ff-spec-val">' + model.ips + '</span><span class="ff-spec-label">IPS</span></div>' +
          '<div class="ff-spec"><span class="ff-spec-val">' + model.conn + '</span><span class="ff-spec-label">Connections</span></div>' +
        '</div>' +
        '<div class="ff-card-users">Recommended for ' + model.users + ' users</div>' +
        priceHTML +
        actionHTML +
      '</div>' +
    '</div>';
  }

  /* ============================================================
     ADD TO CART
     ============================================================ */
  function addToCart(e) {
    var btn = e.currentTarget;
    var productUrl = decodeURIComponent(btn.getAttribute('data-url'));
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch(productUrl + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var variantId = product.variants && product.variants[0] && product.variants[0].id;
        if (!variantId) throw new Error('No variant');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = 'Added!';
        btn.classList.add('ff-added');
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          var counts = document.querySelectorAll('.header-cart-count');
          for (var i = 0; i < counts.length; i++) {
            counts[i].textContent = cart.item_count;
            counts[i].style.display = cart.item_count > 0 ? '' : 'none';
          }
        });
        setTimeout(function() {
          btn.textContent = 'Add to Cart';
          btn.classList.remove('ff-added');
          btn.disabled = false;
        }, 2500);
      })
      .catch(function() {
        btn.textContent = 'Error - Try Again';
        btn.disabled = false;
        setTimeout(function() { btn.textContent = 'Add to Cart'; }, 2000);
      });
  }

  /* ============================================================
     SAVE / LOAD
     ============================================================ */
  function saveResults() {
    var data = { size: state.size, deploy: state.deploy, priority: state.priority, saved: Date.now() };
    try { localStorage.setItem('ntsecurity_firewall_finder', JSON.stringify(data)); } catch (e) {}
    if (window.history.replaceState) {
      var url = new URL(window.location);
      url.searchParams.set('ff', '1');
      url.searchParams.set('size', state.size);
      url.searchParams.set('deploy', state.deploy);
      url.searchParams.set('priority', state.priority);
      window.history.replaceState({}, '', url);
    }
  }
})();
